import * as jsxRuntime from "C:\\TigerSheep\\CustomDevelopment\\bb-customer-portal\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment